import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Router } from '@angular/router';
import * as OrderActions from './order.actions';
import { OrderService } from '../services/order.service';

@Injectable()
export class OrderEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private orderService: OrderService
  ) {}

  getOrderDataEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrderActions.getOrderData),
      switchMap((action) =>
       this.orderService.getOrder(action.orderId).pipe(
          tap(order => console.log(order)),
          map(order => OrderActions.getOrderDataSuccess(order)),
          catchError(() => of(OrderActions.getOrderDataFailure('Error getting order data')))
        )
      )
    )
  );
}
